/* eslint eslint-comments/disable-enable-pair: error */
/* eslint-disable no-undef, no-unused-vars */

import './scss/tailwind.scss';
import './scss/index.scss';

// Make sure JS is enabled and the window is ready.
import './components/js-enabled';
import wdsWindowReady from './components/window-ready';

// Components.
import wdsSwiperSlider from './components/swiper-slider';
import wdsAccordion from './components/accordion';
import wdsMobileMenu from './components/mobile-menu';
import wdsModal from './components/modal';
import wdsPrimaryNav from './components/navigation-primary';
import wdsOffCanvas from './components/off-canvas';
import wdsSkipLinkFocusFix from './components/skip-link-focus-fix';
import wdsTable from './components/table';
import wdsVideo from './components/video';
/* eslint-enable no-undef, no-unused-vars */
